export default "__VITE_ASSET__jvnvOVq7__"